module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Test_01-3f56d1e46f91eb6e05ba8937807aa516.jpg";